import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioGroupFn = /* @__PURE__ */ createRecipe('RadioGroup', {
  "isInline": false,
  "size": "md"
}, [])

const radioGroupVariantMap = {
  "isInline": [
    "true"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ]
}

const radioGroupVariantKeys = Object.keys(radioGroupVariantMap)

export const radioGroup = /* @__PURE__ */ Object.assign(memo(radioGroupFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioGroup',
  __getCompoundVariantCss__: radioGroupFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioGroupVariantKeys,
  variantMap: radioGroupVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioGroupVariantKeys)
  },
  getVariantProps: radioGroupFn.getVariantProps,
})